export default function (Vue) {
  // 获取滚动条最大高度,如滚动条的父级元素有margin-bottom/padding-bottom,则设置value值即可
  Vue.directive('scrollbar-height', {
    inserted: function (el, { value = 0 }, { context }) {

      // 需延迟执行,否则获取的el.offsetTop有误
      context.setMaxHeight = (function () {
        let timer = null
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(_ => {
            const elOffsetTop = el.getBoundingClientRect().top
            const footerDom = document.querySelector('.el-footer')
            const footerHeight = footerDom && footerDom.offsetHeight || 0
            const bodyHeight = document.body.getBoundingClientRect().height
            const maxHeight = bodyHeight - elOffsetTop - footerHeight - value
            el.style.height = maxHeight + 'px'
          }, 100)
        }
      })()
      context.setMaxHeight()
      window.addEventListener('resize', context.setMaxHeight)
    },
    unbind: function (el, binding, { context }) {
      window.removeEventListener('resize', context.setMaxHeight)
    }
  })
}